/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import { isDateValid, isDayInRange } from "./common/dateUtils";
export function getFormattedDateString(date, props, ignoreRange) {
  if (ignoreRange === void 0) {
    ignoreRange = false;
  }

  if (date == null) {
    return "";
  } else if (!isDateValid(date)) {
    return props.invalidDateMessage;
  } else if (ignoreRange || isDayInRange(date, [props.minDate, props.maxDate])) {
    return props.formatDate(date, props.locale);
  } else {
    return props.outOfRangeMessage;
  }
}